// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const BRANCH_CHANGE = 'BRANCH_CHANGE';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const UPDATE = 'UPDATE';
